export class GlobalConstantsComponent {

 //public static globalURL: string = "http://183.82.0.22:8001/hrms/";
 //public static globalURL: string = "http://123.176.35.21/hrms/";
  public static globalURL: string = "https://hrms.datadotlabs.com/hrms/";
  // public static globalURL: string = "http://localhost:8080/hrms/";

}
